/* import __COLOCATED_TEMPLATE__ from './suggestion-card.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import { action } from '@ember/object';
import Component from '@glimmer/component';
import { type BlockGroup } from '../shared/suggestion-editor';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import { taskFor } from 'ember-concurrency-ts';
import Conversation from 'embercom/objects/inbox/conversation';
import { type StreamResourceManager } from 'embercom/components/reporting/custom/report/drill-in-preview-panel';
import { ReviewType } from 'embercom/models/content-service/content-review-request';

interface Args {
  blockGroup: BlockGroup;
  handleBlockGroupSuggestion: (blockGroup: BlockGroup, acceptSuggestion: boolean) => void;
}

export default class SuggestionCard extends Component<Args> {
  @service declare intl: IntlService;
  @service declare navbarCollapsingService: $TSFixMe;

  @action
  handleSuggestion(acceptSuggestion: boolean) {
    this.args.handleBlockGroupSuggestion(this.args.blockGroup, acceptSuggestion);
  }

  get suggestionTitle() {
    if (this.args.blockGroup.reviewType === ReviewType.CREATE_CONTENT) {
      return this.intl.t('knowledge-hub.content-editor.review.ai-suggestion-add');
    }
    return this.intl.t('knowledge-hub.content-editor.review.ai-suggestion-update');
  }

  get reviewRequestCreatedAt() {
    return this.intl.t('knowledge-hub.content-editor.review.suggestion-card.created-from', {
      date: this.intl.formatRelative(this.args.blockGroup.suggestionCreatedAt!),
    });
  }

  get showCard() {
    return (
      this.args.blockGroup.isEdited || this.args.blockGroup.reviewType === ReviewType.CREATE_CONTENT
    );
  }

  get showEditActionButtons() {
    return this.args.blockGroup.reviewType === ReviewType.EDIT_CONTENT;
  }

  @action
  openConversations(streamResourceManager: StreamResourceManager) {
    taskFor(streamResourceManager.showPreviewSideBar).perform(
      this.args.blockGroup.includedConversationIds![0],
      Conversation,
      this.args.blockGroup.includedConversationIds!,
    );
  }

  @action
  onCloseConversationSideBar() {
    if (this.navbarCollapsingService.collapsed) {
      this.navbarCollapsingService.toggleNavbarCollapsed();
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'KnowledgeHub::ContentEditor::ContentReview::SuggestionCard': typeof SuggestionCard;
    'knowledge-hub/content-editor/content-review/suggestion-card': typeof SuggestionCard;
  }
}
